<template>
  <div class="backdrop" v-if="isShow && isMain">
    <div class="popup-container" v-if="isShow && isMain">
      <swiper
        class="swiper notice-slider"
        v-bind="noticeSwiperOptions"
        @swiper="onNoticeSwiper"
      >
        <swiper-slide
          class="swiper-slide"
          v-for="(newPost, index) in newPosts"
          :key="index"
        >
          <!--슬라이드 영역-->
          <component
            :is="newPost?.priorUrl?.length > 1 ? 'a' : 'router-link'"
            :href="newPost?.priorUrl?.length > 1 ? newPost?.priorUrl : null"
            :to="
              newPost?.priorUrl?.length > 1
                ? null
                : {
                    name: ROUTE_NAME.Notice,
                    query: {
                      type: newPost.boardId == 'news' ? 0 : 1,
                      subType: 0,
                      id: newPost.id,
                      viewType: 'view',
                    },
                  }
            "
            style="cursor: pointer"
          >
            <div :class="newPost.boardId == 'news' ? 'notice' : 'event'">
              <img
                :src="
                  newPost?.twPostImages?.find(
                    (it: any) => it.hpImageDiv === 'THUMBNAIL'
                  )?.twImage?.url ??
                  '/src/infrastructure/assets/img/contents/notice-test.jpg'
                "
                alt="newPost.title"
              />
            </div>
          </component>
        </swiper-slide>
      </swiper>
      <div class="slider-btn" v-if="commonStore.isMobile">
        <div class="left">
          <img
            src="@assets/img/mobile/btn_main-popup-prev.svg"
            alt="슬라이드버튼"
            @click="prev"
          />
        </div>
        <div class="right">
          <img
            src="@assets/img/mobile/btn_main-popup-next.svg"
            alt="슬라이드버튼"
            @click="next"
          />
        </div>
      </div>
      <!--      <swiper-->
      <!--        :slides-per-view="commonStore.isMobile ? 1 : 2"-->
      <!--        space-between="4"-->
      <!--        class="main-popup-swiper"-->
      <!--        :loop="banners.total > 2"-->
      <!--        :auto-height="true"-->
      <!--        @swiper="onSwiper"-->
      <!--        @slide-change="handleSlideChange"-->
      <!--      >-->
      <!--        <swiper-slide-->
      <!--          v-for="(slide, index) in banners.twMainBanners"-->
      <!--          :key="index"-->
      <!--          class="swiper-slide"-->
      <!--        >-->
      <!--          <img-->
      <!--            :src="slide.twImage.url"-->
      <!--            alt="메인배너 이미지"-->
      <!--            @click="handleClickSlide(slide)"-->
      <!--          />-->
      <!--        </swiper-slide>-->
      <!--      </swiper>-->
      <!--      <div-->
      <!--        v-if="banners.total !== 2"-->
      <!--        class="custom-swiper-button-prev"-->
      <!--        @click="handleSwiperPrev"-->
      <!--      ></div>-->
      <!--      <div-->
      <!--        v-if="banners.total !== 2"-->
      <!--        class="custom-swiper-button-next"-->
      <!--        @click="handleSwiperNext"-->
      <!--      ></div>-->
      <div class="button-wrapper">
        <!-- <span class="pagination"
          >{{ activeIndex + 1 }}/{{ newPosts.length }}</span
        > -->
        <div class="button">
          <button
            class="close-button"
            aria-label="Close"
            @click="handleClosePopup"
          >
            <img src="@assets/img/contents/icon_menu-close.svg" alt="" />
          </button>
          <label for="dont-show-not-today">
            <input
              id="dont-show-not-today"
              type="checkbox"
              @change="handleNotShowToday"
            />
            오늘 하루 그만 보기
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { RouteLocationNormalized, useRouter } from 'vue-router';
import { ROUTE_NAME } from '@constants';
import { useCommonStore } from '@stores';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Swiper as SwiperClass } from 'swiper/types';
import { useNewMainBoards } from '@infra/composables';
// import dayjs from 'dayjs';
const noticeSwiperInstance = ref<SwiperClass>();

const commonStore = useCommonStore();
const newPosts = ref<any[]>([]);
const isShow = ref(true);
const isMain = ref(false);
// const activeIndex = ref<number>(0);
const router = useRouter();
const noticeSwiperOptions = {
  spaceBetween: 40,
  slidesPerView: commonStore.isMobile ? 1 : 4,
};

const { handleFetchNewMainBoards } = useNewMainBoards();

const handleClosePopup = () => {
  isShow.value = false;
};

const onNoticeSwiper = (swiper: SwiperClass) => {
  noticeSwiperInstance.value = swiper;
};

const checkDoNotShow = () => {
  const doNotShowDate = localStorage.getItem('doNotShowDate');
  const today = new Date().toDateString();

  if (doNotShowDate === today) {
    isShow.value = false;
  }
};
const handleNotShowToday = (event: Event) => {
  const isChecked = (event.target as HTMLInputElement).checked;
  if (isChecked) {
    const today = new Date().toDateString();
    localStorage.setItem('doNotShowDate', today);
  }
  if (!isChecked) {
    localStorage.removeItem('doNotShowDate');
  }
};

const prev = () => {
  noticeSwiperInstance.value?.slidePrev();
};

const next = () => {
  noticeSwiperInstance.value?.slideNext();
};

watch(router.currentRoute, (value: RouteLocationNormalized) => {
  isMain.value = value.name === ROUTE_NAME.Main;
});

onMounted(async () => {
  isMain.value = router.currentRoute.value.name === ROUTE_NAME.Main;
  checkDoNotShow();
  const postsData: any = await handleFetchNewMainBoards({
    limit: 4,
  });
  // newPosts.value = postsData.sort((a: any, b: any) =>
  //   dayjs(a.insertDt).diff(dayjs(b.insertDt))
  // );
  newPosts.value = postsData;
  if (!newPosts.value.length) {
    isShow.value = false;
  }
});
</script>

<style scoped lang="scss">
.backdrop {
  @apply flex fixed bg-black bg-opacity-80 w-screen h-screen left-0 top-0 justify-center items-center;
  z-index: 140;
}
.popup-container {
  @apply mx-auto relative;
  //width: 708px;
  width: 100%;
  max-width: 1385px;
  height: auto;
  //padding: 0 40px;
}
.main-popup-swiper {
  width: 100%;
}
.swiper-slide {
  width: 316px !important;
  height: 316px;
  @apply cursor-pointer;
  img {
    width: 100%;
  }
}
.swiper-slide > a {
  width: 100%;
  height: 100%;
  display: block;
}
.custom-swiper-button-prev,
.custom-swiper-button-next {
  background-color: white;
  position: absolute;
  top: 140px;
  z-index: 50;
  width: 34px;
  height: 53px;
  background-color: rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
//.custom-swiper-button-prev {
//  left: -42px;
//  background: url('@assets/img/icon-swiper-prev.png') no-repeat center center;
//  background-size: contain;
//}
//.custom-swiper-button-next {
//  right: -42px;
//  background: url('@assets/img/icon-swiper-next.png') no-repeat center center;
//  background-size: contain;
//}

.button-wrapper {
  @apply flex justify-center items-center text-white;
  .pagination {
    font-size: 14px;
  }
  .button {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .close-button {
    border-radius: 50%;
    position: relative;
    width: 60px;
    height: 60px;
    border: none;
    background-color: transparent;
    cursor: pointer;
    margin-bottom: 10px;
  }
}

.notice-slider {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0 20px;
  margin-bottom: 45px;
}
.notice,
.event {
  width: 316px;
  height: 316px;
  a {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
.notice-slider .swiper-slide > div {
  cursor: pointer;
  padding: 0 30px 0 30px;
}
.notice-slider a img {
  border-radius: 20px;
}
//.notice-slider:deep {
//  .swiper-wrapper {
//    @apply desktop:justify-center;
//  }
//}
@media (max-width: 884px) {
  .popup-container {
    position: relative;
    @apply mx-auto;
    width: 85%;
  }
  .button-wrapper {
    .pagination {
      @apply hidden;
    }
    .close-button {
      width: 40px;
      height: 40px;
    }
  }
  .notice-slider {
    margin-bottom: 25px;
  }
  .swiper-slide {
    width: 100% !important;
    //height: 100%;
    @apply cursor-pointer;
    img {
      width: 100%;
      object-fit: cover;
    }
  }
  .notice,
  .event {
    width: 100%;
    height: 100%;
    a {
      width: 100%;
      height: 100%;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .slider-btn {
    position: absolute;
    top: calc(50% - 50px);
    transform: translateY(-50%);
    width: 100%;
    z-index: 99;
  }
  .slider-btn .left {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -15px;
    cursor: pointer;
  }
  .slider-btn .right {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -15px;
    cursor: pointer;
  }
  .custom-swiper-button-prev,
  .custom-swiper-button-next {
    top: 100px;
  }
}
</style>
